import LastElementTable from "components/shared/LastElementTable";
import type { LastElementTableColumns } from "components/shared/LastElementTable/type";
import { SmallBody } from "helpers/TypographyComponents";
import { formatLocaleDateString } from "helpers/utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { DTOProcessedS3File } from "store/automatedImportStore/types";
import { EFetchStatus } from "store/types";

import { EdiFileName, RowActions, RowCollapseContent } from "./FormatTableColumns";

interface EdiFilesTableProps {
    ediFiles: DTOProcessedS3File[];
    ediFilesStatus: EFetchStatus;
}

const EdiFilesTable = ({ ediFiles, ediFilesStatus }: EdiFilesTableProps) => {
    const [t] = useTranslation();
    const [selectedFile, setSelectedFile] = useState<string>("");

    const columns: LastElementTableColumns[] = [
        {
            id: "suggestedFileName",
            label: t("Settings.EDIInterforum.FileName"),
            align: "left",
            format: (value, id, currentRow) => <EdiFileName row={currentRow} />,
        },
        {
            id: "processedAt",
            label: t("Settings.EDIInterforum.ProcessedAt"),
            align: "left",
            sort: true,
            format: (value) => (
                <SmallBody>
                    {formatLocaleDateString({
                        date: value,
                        options: { numeric: true, showTime: true, timeZone: "UTC" },
                    })}
                </SmallBody>
            ),
        },
        {
            id: "EDIFileType",
            label: "Type",
            align: "left",
        },
        {
            id: "action",
            label: "Action",
            align: "right",
            format: (value, id, currentRow) => <RowActions row={currentRow} />,
        },
    ];

    const onRowClick = (id: number, id2: string, type: string, row: DTOProcessedS3File) => {
        setSelectedFile((prev) => (prev === row.ediIdentifier ? "" : row.ediIdentifier));
    };

    return (
        <LastElementTable
            data={ediFiles}
            columns={columns}
            max={-1}
            isLoading={ediFilesStatus !== EFetchStatus.FULFILLED}
            onRowClick={onRowClick}
            collapseOn={(row) => (row.ediIdentifier === selectedFile ? "ediIdentifier" : "")}
            collapseContent={(row) => <RowCollapseContent row={row} />}
            collapseSelectedBackground="#F6F6F6"
            columnsNumber={columns.length}
            stickyFooter
        />
    );
};

export default EdiFilesTable;
